import { loadStripe, type Stripe } from "@stripe/stripe-js";

export type StripeEnv = "sandbox" | "live";

/**
 * Live publishable key (public by design). The preview host injects a test
 * publishable key into the environment, which would silently put the preview
 * in test mode. The business runs everything in live mode, so a test token is
 * ignored and the live key below is used instead.
 *
 * To go back to test mode, set VITE_PAYMENTS_CLIENT_TOKEN to a pk_test_ key
 * AND flip ALLOW_TEST_MODE to true.
 */
const LIVE_CLIENT_TOKEN =
  "pk_live_51TQ2dEDGLnMNCUw1ileAjHCHsAIto1317H5cGGj2B1yWP5WA4IB8fTXdL5o1OZJCupzFgoujIeMQsXwNmQFO1ben00gSa6vFpI";

const ALLOW_TEST_MODE = false;

const envToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

const clientToken =
  envToken && (ALLOW_TEST_MODE || envToken.startsWith("pk_live_"))
    ? envToken
    : LIVE_CLIENT_TOKEN;

export const stripeEnvironment: StripeEnv = clientToken.startsWith("pk_test_")
  ? "sandbox"
  : "live";

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(clientToken);
  }
  return stripePromise;
}
